import { render } from "./List.vue?vue&type=template&id=4f75bce9&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=4f75bce9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f75bce9"

export default script